import { OrdersStore } from '../stores/orders';
import { cleanCompaniesStore, getCompaniesSelect } from './companies';
import { setUiTotal } from './ui';
import { apiManager } from '../REST';
import { IBodyListResponse, IOrdersListAPI, IOrdersListItem, IParamsList } from '../interfaces';
import { mapApi2UiField } from '../instruments';

export function cleanOrdersStore(): void {
    const StoreInstance = OrdersStore.getInstance();
    StoreInstance.cleanStore();
}

export function setOrdersList(apiData: IOrdersListAPI): void {
    const storeData: IOrdersListItem[] = apiData.orders?.map((order) => {
        return {
            ...mapApi2UiField(order || {}),
        };
    }) as IOrdersListItem[];

    const StoreInstance = OrdersStore.getInstance();
    StoreInstance.setList(storeData);
}

export async function getOrdersList(params: IParamsList): Promise<number> {
    const { resp } = await apiManager.getApi('GET_ORDERS_LIST', { searchParamsList: params });
    const { meta } = resp as IBodyListResponse;
    meta && setUiTotal(meta.records_count);
    resp && setOrdersList(resp as IOrdersListAPI);
    return Number(meta?.records_count);
}

export function getOrdersListRelationSelect(): void {
    getCompaniesSelect();
}

export function cleanOrdersRelationSelectAndStore(): void {
    cleanCompaniesStore();
    cleanOrdersStore();
}

export function setOrdersForcedUpdateTime(): void {
    const StoreInterface = OrdersStore.getInstance();
    StoreInterface.setForcedUpdateTime();
}
